export default __webpack_public_path__ + "static/media/dz.e749e3b0.svg";